import React from 'react';

function NewsFeed() {
  return (
    <div>
      <h2 className="text-3xl font-bold mb-4">News Feed</h2>
      <ul className="list-disc ml-6">
        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
        <li>Nulla euismod felis sed mauris tincidunt aliquam.</li>
        <li>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</li>
        <li>Fusce eu justo nec metus fringilla tincidunt a sit amet odio.</li>
        <li>Vestibulum malesuada eros ut urna placerat, eu elementum erat volutpat.</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
        <li>Nulla euismod felis sed mauris tincidunt aliquam.</li>
        <li>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</li>
        <li>Fusce eu justo nec metus fringilla tincidunt a sit amet odio.</li>
        <li>Vestibulum malesuada eros ut urna placerat, eu elementum erat volutpat.</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
        <li>Nulla euismod felis sed mauris tincidunt aliquam.</li>
        <li>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</li>
        <li>Fusce eu justo nec metus fringilla tincidunt a sit amet odio.</li>
        <li>Vestibulum malesuada eros ut urna placerat, eu elementum erat volutpat.</li>
      </ul>
    </div>
  );
}

export default NewsFeed;
